var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8062_4081",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42667 2.23193H11.5731C11.9367 2.23192 12.2499 2.23191 12.4938 2.25373C12.7272 2.27462 13.0343 2.32285 13.2783 2.52697C13.5847 2.78315 13.7522 3.16877 13.7305 3.56749C13.7132 3.88518 13.5389 4.14258 13.3949 4.32747C13.2445 4.5207 13.0308 4.74957 12.7826 5.01545L9.9332 8.06843L9.9332 13.9387C9.93324 14.0181 9.93328 14.1139 9.92576 14.196C9.91814 14.279 9.89637 14.4532 9.77544 14.6161C9.63792 14.8012 9.42719 14.918 9.1973 14.9365C8.99512 14.9527 8.83586 14.8789 8.76141 14.8413C8.68786 14.8042 8.60663 14.7534 8.53929 14.7113L6.49102 13.4312C6.45569 13.4099 6.34476 13.343 6.25908 13.243C6.18858 13.1607 6.13552 13.065 6.10313 12.9616C6.06375 12.8359 6.06577 12.7064 6.06642 12.6651L6.06653 8.06843L3.21708 5.01546C2.9689 4.74957 2.75527 4.52069 2.60478 4.32747C2.46077 4.14258 2.28652 3.88518 2.26921 3.56749C2.2475 3.16877 2.41507 2.78315 2.72137 2.52697C2.96543 2.32285 3.2725 2.27462 3.50593 2.25373C3.74985 2.23191 4.06298 2.23192 4.42667 2.23193ZM3.46659 3.51123C3.46751 3.51744 3.47 3.52821 3.48529 3.54459L7.10518 7.42305C7.20888 7.53415 7.26655 7.68046 7.26655 7.83244V12.5012L8.73322 13.4179V7.83244C8.73322 7.68046 8.79089 7.53415 8.89459 7.42305L12.5145 3.5446C12.5298 3.52821 12.5323 3.51744 12.5332 3.51123C12.5345 3.50197 12.5336 3.48806 12.5269 3.47254C12.5201 3.45702 12.5106 3.44686 12.5029 3.44153C12.4977 3.43797 12.4882 3.43244 12.4657 3.43244H3.53403C3.51162 3.43244 3.50205 3.43797 3.49688 3.44153C3.48917 3.44686 3.47963 3.45702 3.47288 3.47254C3.46614 3.48806 3.46522 3.50197 3.46659 3.51123Z",
    fill: "#1B1C1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8062_4081)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#1B1C1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.0931cc5c6cbb8ddfe6c1fa12b8d5f9a6.svg";
export { ForwardRef as ReactComponent };